export default {
    state: {
        id: '',
        theme: '',
        fetchingBrands: false,
        brandsErrors: null,
        brands: null,
        fetchingCandidates: false,
        candidates: null,
        candidatesErrors: null
    },
    mutations: {
        userId(state, userId) {
            state.id = userId;
        },
        theme(state, theme) {
            state.theme = theme;
        },
        fetchingBrands(state) {
            state.fetchingBrands = true;
            state.brands = null;
            state.brandsErrors = null;
        },
        brandsErrors(state, errors) {
            state.fetchingUserBrands = false;
            state.brandsErrors = errors;
        },
        brands(state, result) {
            state.fetchingBrands = false;
            state.brands = result;
        },
        fetchingCandidates(state) {
            state.fetchingCandidates = true;
        },
        candidates(state, candidates) {
            state.candidates = candidates;
        },
        candidatesErrors(state, errors) {
            state.candidatesErrors = errors;
        }
    },
    actions: {
        setUserId({commit}, userId) {
            commit('userId', userId);
        },
        setTheme({commit}, theme) {
            if (theme && theme.toLowerCase() === 'theme4d'){
                commit('theme', 'lightning');
            } else {
                commit('theme', 'classic');
            }
        }
    }
}